@if (translation) {
  <span class="body-s header">
    {{ translation | translate }}
    @if (feature | benefitFlag; as flag) {
      <ui-asset [name]="flag" set="flags" />
    }
  </span>
} @else {
  <ui-product-platform-cell class="header" [platform]="feature" />
}

<div class="cells">
  @for (feature of featureMappings; track feature.id) {
    <mkp-product-feature-cell [feature]="feature" />
  }
</div>
